import SiteLayout from "@/components/feature/SiteLayout";
import { useDocumentMeta, SITE_ORIGIN } from "@/hooks/useDocumentMeta";
import { communityFaq } from "@/mocks/faq";
import { communityPosts } from "@/mocks/posts";
import { siteInfo } from "@/mocks/site";
import Hero from "./components/Hero";
import TickerBar from "./components/TickerBar";
import StatsBar from "./components/StatsBar";
import FeaturedSection from "./components/FeaturedSection";
import RankingSection from "./components/RankingSection";
import CategorySection from "./components/CategorySection";
import RepliesSection from "./components/RepliesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FaqSection from "./components/FaqSection";
import SubscribeSection from "./components/SubscribeSection";

export default function Home() {
  useDocumentMeta({
    title: "黑料网社 - 热帖专区｜高赞神回复与加精置顶热评一站看够",
    description:
      "黑料网社热帖专区，聚合当日热帖、高赞神回复与加精置顶热评，热评区金句频出，围观群众不迷路。想快速 get 今日最火瓜，直接刷热帖榜就完事。",
    keywords: "黑料网社,黑料网社热帖,黑料网社高赞,黑料网社神回复,黑料网社加精,吃瓜社区",
    path: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: siteInfo.name,
        url: SITE_ORIGIN,
        inLanguage: "zh-CN",
        description: siteInfo.intro,
        potentialAction: {
          "@type": "SearchAction",
          target: `${SITE_ORIGIN}/hot?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: siteInfo.name,
        url: SITE_ORIGIN,
        email: siteInfo.email,
        foundingDate: String(siteInfo.since),
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "实时热帖榜",
        itemListElement: [...communityPosts]
          .sort((a, b) => b.heat - a.heat)
          .slice(0, 6)
          .map((post, index) => ({
            "@type": "ListItem",
            position: index + 1,
            name: post.title,
            url: `${SITE_ORIGIN}/post/${post.id}`,
          })),
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: communityFaq.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: { "@type": "Answer", text: item.a },
        })),
      },
    ],
  });

  return (
    <SiteLayout>
      <Hero />
      <TickerBar />
      <StatsBar />
      <FeaturedSection />
      <RankingSection />
      <CategorySection />
      <RepliesSection />
      <TestimonialsSection />
      <FaqSection items={communityFaq} />
      <SubscribeSection />
    </SiteLayout>
  );
}